import { create } from 'zustand'
import type { WalletCurrency } from '@/domain/wallet/walletApi'
import type { CryptoAmount, FiatAmount } from '@/types'
import type {
  UnigoxOffRampPaymentRail,
  UnigoxOffRampInstitution,
  UnigoxOffRampPaymentDetailsDTO,
} from '@/domain/wallet/walletTypes'

interface WithdrawOffRampState {
  isFiatMode: boolean
  triggerShake: boolean
  cryptoAmount: CryptoAmount
  fiatAmount: FiatAmount
  selectedCryptoWalletData?: WalletCurrency
  selectedReceivingCurrency?: { code: string; name: string }
  selectedBank?: UnigoxOffRampInstitution
  selectedRail?: UnigoxOffRampPaymentRail
  selectedPaymentDetails?: UnigoxOffRampPaymentDetailsDTO
  rails: UnigoxOffRampPaymentRail[]
  offRampBankFields: Record<string, string>
  paymentDetailsId?: string
  pricePerUnit?: number
}

interface WithdrawOffRampActions {
  setIsFiatMode: (v: boolean) => void
  shakeComponent: () => void
  setCryptoAmount: (v?: CryptoAmount) => void
  setFiatAmount: (v?: FiatAmount) => void
  setPricePerUnit: (v?: number) => void
  setSelectedCryptoWalletData: (v: WalletCurrency) => void
  setSelectedReceivingCurrency: (v?: { code: string; name: string }) => void
  setSelectedBank: (v?: UnigoxOffRampInstitution) => void
  setSelectedRail: (v?: UnigoxOffRampPaymentRail) => void
  setSelectedPaymentDetails: (v?: UnigoxOffRampPaymentDetailsDTO) => void
  setRails: (v: UnigoxOffRampPaymentRail[]) => void
  setOffRampBankFields: (v: Record<string, string>) => void
  setPaymentDetailsId: (v: string) => void
  resetWithdrawOffRampStore: () => void
}

const initialState: WithdrawOffRampState = {
  isFiatMode: true,
  triggerShake: false,
  cryptoAmount: { amount: '0', code: 'USDT' },
  fiatAmount: { amount: '0', code: 'USD' },
  rails: [],
  offRampBankFields: {},
}

export const useWithdrawOffRampStore = create<
  WithdrawOffRampState & WithdrawOffRampActions
>()((set) => ({
  ...initialState,
  setIsFiatMode: (isFiatMode) => set({ isFiatMode }),
  shakeComponent: () => {
    set({ triggerShake: true })
    setTimeout(() => set({ triggerShake: false }), 600)
  },
  setCryptoAmount: (cryptoAmount) => set({ cryptoAmount }),
  setFiatAmount: (fiatAmount) => set({ fiatAmount }),
  setPricePerUnit: (pricePerUnit) => set({ pricePerUnit }),
  setSelectedCryptoWalletData: (selectedCryptoWalletData) =>
    set({ selectedCryptoWalletData }),
  setSelectedReceivingCurrency: (selectedReceivingCurrency) =>
    set({ selectedReceivingCurrency }),
  setSelectedBank: (selectedBank) => set({ selectedBank }),
  setSelectedRail: (selectedRail) => set({ selectedRail }),
  setSelectedPaymentDetails: (selectedPaymentDetails) =>
    set({ selectedPaymentDetails }),
  setRails: (rails) => set({ rails }),
  setOffRampBankFields: (offRampBankFields) => set({ offRampBankFields }),
  setPaymentDetailsId: (paymentDetailsId) => set({ paymentDetailsId }),
  resetWithdrawOffRampStore: () => set({ ...initialState }),
}))
